// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { ProductsState } from "@store/Framework/Store/Store/Data/Products/ProductsState";

const initialState: ProductsState = {
    realTimePriceLoading: {},
};

const actions = {
    "Store/Data/Products/BeginLoadRealTimePrice": (draft: Draft<ProductsState>, action: { productId: string }) => {
        draft.realTimePriceLoading[action.productId] = true;
    },
    "Store/Data/Products/CompleteLoadRealTimePrice": (draft: Draft<ProductsState>, action: { productId: string }) => {
        delete draft.realTimePriceLoading[action.productId];
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ProductsActions = Parameters<typeof reducer>[1];
export default reducer;
